import axios from "axios";
import { toast } from "react-toastify";

const baseURL = process.env.REACT_APP_API_URL || "https://api.example.com";

const axiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("admin_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl: string = error.config?.url || "";
    // Failed sign-in attempts are reported by the sign-in page. Handling them
    // here would redirect back to /admin/sign-in and discard the message.
    const isLoginRequest = /\/(login|admin-login)$/.test(requestUrl.split("?")[0]);

    if (isLoginRequest) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401) {
      // console.log(error, "error.response?.message");
      toast.error(
        error.response?.data?.message || "Session expired. Please log in again."
      );
      // toast.error("Session expired. Please log in again.");
      localStorage.removeItem("admin_token");
      localStorage.removeItem("user");
      window.location.href = "/admin/sign-in";
    }
    if (
      error &&
      error.response &&
      error.response.data &&
      error.response.data &&
      error.response.data.errors &&
      error.response.data.errors.length > 0
    ) {
      // // // console.log(error.response.data.errors,'error.response.data.errors');

      error.response.data.errors.forEach((error: any) => {
        toast.error(error.msg);
      });
    } else if (
      error.response?.status === 400 &&
      error &&
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      toast.error(error.response.data.message);
    }
    // console.error(error, "eeeeeeeeee");
    return Promise.reject(error);
  }
);

export default axiosInstance;
